"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosStyleError = exports.JSON_CONTENT_TYPE = exports.WIX_HIVE_HIT_HEADER = exports.CDN_HIT_HEADER = exports.CONTENT_TYPE_HEADER = void 0;
exports.CONTENT_TYPE_HEADER = 'content-type';
exports.CDN_HIT_HEADER = 'age';
exports.WIX_HIVE_HIT_HEADER = 'x-cache-status';
exports.JSON_CONTENT_TYPE = 'application/json';
exports.isAxiosStyleError = function (httpResponseError) {
    return !!(httpResponseError.response && httpResponseError.response.data && httpResponseError.response.status);
};
